
declare var require: any;

export function highchartsFactory() {
  const hc = require('highcharts');
  const hcdd = require('highcharts/modules/drilldown');
  const hcMore = require('highcharts/highcharts-more');

  // Load native Highcharts modules instead of vulnerable bundled package
  const hcHistogram = require('highcharts/modules/histogram-bellcurve');

  hcMore(hc);
  hcHistogram(hc);
  hcdd(hc);
  return hc;
}
